export const createIconByFullName = (firstName = 'Unknown', secondName = 'User'): string => {
  const firstLetter = firstName[0] ?? 'U';
  const secondLetter = secondName[0] ?? 'U';
  return `${firstLetter.toLocaleUpperCase()}${secondLetter.toLocaleUpperCase()}`;
};
